import script from "./FeedbackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=5bd277d5&lang=scss"

const __exports__ = script;

export default __exports__